module.exports = __webpack_public_path__ + "static/img/identity_card_two.573da94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identity_card_two.png
// module id = /+2r
// module chunks = 1